import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import {
  CalendlyCurrentUser,
  CalendlyIntegrationConfig
} from '@dadohr/shared/domainTypes/integrations/calendly';
import { FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import { useFirebaseFunction } from '../../../../../../services/firebaseFunctions';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toCalendlyConfigDoc = generateToDocFn<CalendlyIntegrationConfig>();

const collection = () => store().collection(FS.calendlyIntegrationConfig);

export const calendlyConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toCalendlyConfigDoc
);

export const useCalendlyConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(calendlyConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<CalendlyIntegrationConfig> = {
          id: orgId,
          collection: FS.calendlyIntegrationConfig,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,

            accessToken: '',
            refreshToken: '',
            webhooks: []
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

const toUrl = (fnName: string) => `integrations_calendly-${fnName}`;

export const useCalendlyCurrentUser = (orgId: string) => {
  return useFirebaseFunction<CalendlyCurrentUser>(
    toUrl('currentUser'),
    { orgId },
    [orgId]
  );
};

export const removeCalendlyConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};
